import React, { lazy, Suspense } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { routerUtil } from '@utils/config'
import { Loading } from '@com-components/'

const Product = lazy(() => import('@pages/policy/product/index'))
const WhiteList = lazy(() => import('@pages/policy/white-list/index'))
const ProductDetail = lazy(() => import('@pages/policy/product-detail'))
const Customer = lazy(() => import('@pages/policy/customer/index'))
const CustomerDetail = lazy(() => import('@pages/policy/customer-detail/index'))
const CustomerMonitor = lazy(() => import('@pages/policy/customer-monitor/index'))

export const routerConfig = [
  {
    name: '策略管理',
    children: [
      { name: '策略详情', path: '/policy/product/:id', hideInMenu: true, component: ProductDetail },
      { name: '策略列表', path: '/policy/product', component: Product },
      { name: '白名单', path: '/policy/whiteList', component: WhiteList },
    ]
  },
  {
    name: '客户策略设置',
    children: [
      { name: '客户', path: '/policy/customer/:id', hideInMenu: true, component: CustomerDetail },
      { name: '客户列表', path: '/policy/customer', component: Customer },
      { name: '风险客户监控', path: '/policy/monitor', component: CustomerMonitor }
    ]
  }
]
const routerMap = routerUtil.sortToRoute(routerConfig)

const PolicyRoutes = () => (
  <Suspense fallback={<Loading />}>
    <Switch>
      {routerMap.map(route => (
        <Route key={route.path} path={route.path} component={route.component} />
      ))}
      <Redirect to="/policy/customer" />
    </Switch>
  </Suspense>
)

export default PolicyRoutes
